// Quick piece sizes (in mm). User can also use a "custom" size.
export const PIECE_FORMATS = [
  { id: "tarjeta-h", label: "Tarjeta horizontal", width_mm: 87, height_mm: 57 },
  { id: "tarjeta-v", label: "Tarjeta vertical", width_mm: 52, height_mm: 92 },
  { id: "mp-small", label: "Marcapáginas pequeño", width_mm: 140, height_mm: 55 },
  { id: "mp-large", label: "Marcapáginas grande", width_mm: 170, height_mm: 70 },
  { id: "foto-5x9", label: "Foto 5 × 9", width_mm: 50, height_mm: 90 },
  { id: "foto-8x8", label: "Foto 8 × 8", width_mm: 80, height_mm: 80 },
  { id: "foto-10x10", label: "Foto 10 × 10", width_mm: 100, height_mm: 100 },
  { id: "foto-10x15", label: "Foto 10 × 15", width_mm: 100, height_mm: 150 },
  { id: "foto-15x20", label: "Foto 15 × 20", width_mm: 150, height_mm: 200 },
];

export const DEFAULT_PIECE = {
  id: "tarjeta-h",
  label: "Tarjeta horizontal",
  width_mm: 87,
  height_mm: 57,
};

export const getPieceFormat = (id) =>
  PIECE_FORMATS.find((p) => p.id === id) || PIECE_FORMATS[0];

export const BLEED_OPTIONS = [0, 1, 2, 3, 5];
